import { PageRef } from 'providers/page-ref';

export type AwaitingCoachPageParams = {};

// Holding page shown to a client during option-B coach onboarding (#3389)
// once they have finished the intake wizard and the coach has not yet
// finalized the plan. Reached only via getPageByWelcomePhase() when the
// plan's welcomePhase is AwaitingCoachFinalize.
export const IAwaitingCoachPage: PageRef<AwaitingCoachPageParams, void> = {
  pageName: 'AwaitingCoachPage',
} as PageRef<AwaitingCoachPageParams, void>;
